import { Injectable } from '@angular/core';
import { applicationConstants } from 'src/app/shared/applicationConstants';
import { Language } from '../../../analytics/newrelic/model/newrelic.model';
import { ContactMessageModel } from '../../../shared/services/evergent/onboarding/model/get-profiles/get-contact-response.model';
import { ClevertapEvent } from '../enum/clevertap.eventType';
import { LanguageInfo } from '../models/clevertap.model';
import { getPreferredLanguages } from 'src/app/shared/utils/deviceUtils';
import { DataService } from 'src/app/data.service';
import { KEYS } from 'src/app/shared/utils/constants/storage.constants';
import { LocalStorageService } from 'src/app/shared/services/storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ClevertapBaseStore {
  constructor(
    private readonly dataService: DataService,
    private readonly localStorage: LocalStorageService
  ) {}

  public getLanguageInfo(): LanguageInfo {
    const contentLanguage =
      localStorage?.getItem('watch-lang') === 'te'
        ? Language.TELUGU
        : Language.TAMIL;
    const displayLanguage = localStorage.getItem('lang');
    const getDisplayLanguage = () => {
      if (displayLanguage === 'te') {
        return Language.TELUGU;
      }
      return displayLanguage === 'en' ? Language.ENGLISH : Language.TAMIL;
    };
    return {
      contentLanguage: getPreferredLanguages(
        this.dataService.isFromDeeplink
          ? this.localStorage.getItem(KEYS.DL_PREFERRED_LANGUAGES)
          : null
      ),
      displayLanguage: getDisplayLanguage(),
    };
  }

  public getBaseAttributesByPlanData(
    planData: any,
    eventName: ClevertapEvent
  ): any {
    let actualPrice: number = 0;
    if (!planData) {
      return {};
    }

    planData.attributes?.forEach((attribute: any) => {
      if (attribute.attributeLabel === 'price') {
        actualPrice = attribute.attributeValue;
      }
    });
    actualPrice =
      actualPrice === undefined ? planData?.retailPrice : actualPrice;

    if (eventName === ClevertapEvent.SUBSCRIPTION_INITIATED) {
      return {
        paymentPlan: planData?.period,
        planID: planData?.skuORQuickCode,
        currency: planData?.currencyCode,
        actualPrice,
        discountedPrice:
          actualPrice === planData?.retailPrice ? undefined : planData?.retailPrice,
      };
    }

    return {
      offerApplied: planData?.selectedPromotion?.promotionId || undefined,
      paymentPlan: planData?.period,
      planID: planData?.skuORQuickCode,
      currency: planData?.currencyCode,
      actualPrice,
      discountedPrice:
        actualPrice === planData?.retailPrice ? undefined : planData?.retailPrice,
      transactionAmount: planData?.retailPrice,
      paymentMode: undefined,
      paymentSubMode: undefined,
      paymentSubModeOffer: undefined,
    };
  }

  public getBaseAttributesByEvent(eventName: ClevertapEvent): any {
    if (!eventName) {
      return {};
    }
    if (eventName === ClevertapEvent.SUBSCRIPTION) {
      return this.getDeviceInfo(); // as per new relic data
    } else {
      return {};
    }
  }

  public getDeviceInfo() {
    const newTxt = navigator.userAgent.split('(');
    const useragentdata = [];
    for (let i = 1; i < newTxt.length; i++) {
      useragentdata.push(newTxt[i].split(')')[0]);
    }

    const defaultModel = navigator.userAgent.includes('Web0S')
      ? 'Web0S'
      : 'Tizen';

    return {
      deviceName: applicationConstants.DEVICE_NAME,
      deviceGroup: 'TV',
      deviceManufacturer: navigator.userAgent.includes('Web0S')
        ? 'LG Electronics Inc'
        : 'Samsung',
      deviceModel: window.deviceModel || defaultModel,
    };
  }

  public getDemographyInfo() {
    const demographyUserInfo: ContactMessageModel = JSON.parse(
      sessionStorage.getItem('mainContact') || '{}'
    );
    const name = demographyUserInfo?.firstName || '';
    const gender = demographyUserInfo?.gender || '';
    const dob = demographyUserInfo?.dateOfBirth
      ? new Date(demographyUserInfo?.dateOfBirth).toLocaleDateString('en-GB')
      : '';

    return {
      name,
      gender,
      dob,
    };
  }
}
